<template>
  <div class="gantt">
    <div class="gantt__container" ref="gantt"></div>
  </div>
</template>

<script>
import { gantt } from 'dhtmlx-gantt'
export default {
  name: 'PlanningGeneralScheduleGantt',
  props: {
    tasks: {
      type: Object,
      default() {
        return { data: [], links: [] }
      },
    },
    projectName: {
      type: String,
      default() {
        return 'Project name'
      },
    },
  },
  data() {
    return {}
  },
  mounted() {
    gantt.plugins({
      tooltip: true,
      drag_timeline: true,
      marker: true,
    })
    var webStatisticProjectText = this.localStorage.translations.pages.statistic_project.text
    var projectStatusTranslation =
      this.localStorage.translations.pages.sales_project['planned_resources-labels'][
        'status-proekta'
      ]
    var translationWorkType =
      this.localStorage.translations.pages['setting-work_type'].tables['vid-rabot']
    const projectStatusText = (value) => {
      if (value === 'creating') {
        return this.localStorage.translations.pages.projects_status.status['predvaritelnyy'] || ''
      } else if (value === 'bidding') {
        return (
          this.localStorage.translations.pages.projects_status.status['tsenopredlozhenie'] || ''
        )
      } else if (value === 'canceled') {
        return (
          this.localStorage.translations.pages.projects_status.status['ne-sostoyavshiysya'] || ''
        )
      } else if (value === 'pending') {
        return this.localStorage.translations.pages.projects_status.status['v-ozhidanii'] || ''
      } else if (value === 'in_progress') {
        return this.localStorage.translations.pages.projects_status.status['v-rabote'] || ''
      } else if (value === 'done') {
        return this.localStorage.translations.pages.projects_status.status['zavershen'] || ''
      } else if (value === 'intro') {
        return this.localStorage.translations.pages.projects_status.status['beginer'] || ''
      } else {
        return ''
      }
    }
    this.ganttAddTodayMarker()
    // gantt.config.autosize = 'y'
    gantt.config.xml_date = '%d.%m.%Y'
    gantt.config.date_grid = '%d.%m.%Y'
    gantt.i18n.setLocale($cookies.get('languageSelect').key)
    // gantt.config.task_height = 24
    gantt.templates.task_text = function (start, end, task) {
      return task.label
    }
    gantt.config.scale_height = 90
    gantt.config.row_height = 52
    gantt.config.task_height = 48
    gantt.config.grid_resize = true

    gantt.config.scales = [
      { unit: 'month', step: 1, format: '%F, %Y' },
      {
        unit: 'week',
        step: 1,
        format: function (date) {
          return '№' + gantt.date.getWeek(date)
        },
      },
      { unit: 'day', step: 1, format: '%j, %D' },
    ]
    gantt.templates.grid_open = function (item) {
      return (
        "<div class='gantt_tree_icon gantt_" +
        (item.$open ? 'close' : 'open') +
        "'><svg width='6' height='10' viewBox='0 0 6 10' fill='none' xmlns='http://www.w3.org/2000/svg'>" +
        "<path d='M0.279313 0.280602C0.100414 0.458339 -4.0657e-07 0.698769 -3.95615e-07 0.949381C-3.8466e-07 1.19999 0.100414 1.44042 0.279313 1.61816L3.67957 5.02372L0.279313 8.38184C0.100415 8.55958 -5.24533e-08 8.80001 -4.14987e-08 9.05062C-3.05441e-08 9.30123 0.100415 9.54166 0.279313 9.7194C0.368606 9.80831 0.474841 9.87888 0.59189 9.92704C0.708939 9.9752 0.834485 10 0.961285 10C1.08809 10 1.21363 9.9752 1.33068 9.92704C1.44773 9.87888 1.55396 9.80831 1.64326 9.7194L5.71588 5.69724C5.80591 5.60905 5.87736 5.50413 5.92613 5.38853C5.97489 5.27294 6 5.14895 6 5.02372C6 4.89849 5.97489 4.7745 5.92613 4.6589C5.87736 4.5433 5.80591 4.43838 5.71588 4.35019L1.64326 0.280602C1.55396 0.191689 1.44773 0.121118 1.33068 0.072957C1.21363 0.0247964 1.08809 -4.75617e-08 0.961285 -4.20191e-08C0.834484 -3.64765e-08 0.708938 0.0247965 0.59189 0.072957C0.474841 0.121118 0.368606 0.191689 0.279313 0.280602Z' fill='#16558F'/>" +
        '</svg></div>'
      )
    }
    gantt.templates.tooltip_text = function (start, end, task) {
      let project =
        "<div class='gantt-custom__tooltip__item'><b>" +
        projectStatusTranslation +
        ':</b>' +
        ' ' +
        projectStatusText(task.status) +
        '</div>'

      let employee =
        "<div class='gantt-custom__tooltip__item'><b>" +
        translationWorkType +
        ':</b>' +
        ' ' +
        task.work_type_name +
        '</div>'

      return (
        "<div class='f14 gantt-custom__tooltip'>" +
        "<div class='gantt-custom__tooltip__item'><b>" +
        task.text +
        '</b>' +
        '</div>' +
        "<div class='gantt-custom__tooltip__item'><b>" +
        webStatisticProjectText['data-nachala'] +
        ':</b>' +
        ' ' +
        task.start_date.toLocaleDateString() +
        '</div>' +
        "<div class='gantt-custom__tooltip__item'><b>" +
        webStatisticProjectText['data-okonchaniya'] +
        ':</b>' +
        ' ' +
        task.end_date.toLocaleDateString() +
        '</div>' +
        (task.type === 'object' ? project : task.type === 'employee' ? employee : '') +
        '</div>'
      )
    }
    gantt.templates.grid_folder = function (item) {
      return null
    }
    gantt.templates.grid_file = function (item) {
      return null
    }
    gantt.config.readonly = true
    gantt.custom_template = (id, columnName) => {
      var item = gantt.getTask(id)
      if (item && item.type === 'employee') {
        let imgLink = this.apiDomain + '/min/' + item.photo
        if (item.photo) {
          return (
            "<div class='gantt-custom__template " +
            (item.group ? 'gantt-custom__template--group' : '') +
            "'>" +
            "<div class='gantt-custom__template__photo'><img  src=" +
            imgLink +
            '></div>' +
            item.text +
            '</div>'
          )
        } else {
          return (
            "<div class='gantt-custom__template " +
            (item.group ? 'gantt-custom__template--group' : '') +
            "'>" +
            "<div class='gantt-custom__template__photo gantt-custom__template__photo--none'>" +
            '<span class="initials f12">' +
            item.first_name.charAt(0) +
            item.last_name.charAt(0) +
            '</span>' +
            '</div>' +
            item.text +
            '</div>'
          )
        }
      } else if (item && item.type === 'object') {
        return (
          "<div class='gantt-custom__template gantt-custom__template--title''>" +
          item.text +
          '</div>'
        )
      } else {
        return "<div class='gantt-custom__template'>" + item.text + '</div>'
      }
    }
    gantt.config.columns = [
      {
        name: 'text',
        label:
          this.localStorage.translations.pages.planning_orders.table.nazvanie || this.projectName,
        template: (task) => gantt.custom_template(task.id, 'progress'),
        tree: true,
        width: 400,
        min_width: 400,
        resize: true,
      },
    ]
    gantt.templates.task_text = function (start, end, task) {
      if (task.type === 'employee') {
        return "<span class='text-gannt'>" + task.work_type_name + ' - ' + task.text + '</span>'
      } else return "<span class='text-gannt'>" + task.text + '</span>'
    }

    gantt.init(this.$refs.gantt)
    gantt.parse(this.$props.tasks)
  },
  computed: {
    apiDomain() {
      return this.$store.state.apiDomain
    },
  },

  methods: {
    updateGantt() {
      this.ganttClearAll()
      gantt.parse(this.$props.tasks)
      gantt.sort('start_date', false)
      gantt.showDate(new Date().setHours(0, 0, 0, 0))
      gantt.attachEvent('onAfterTaskUpdate', function (id, item) {
        gantt.sort('start_date', false)
      })

      gantt.attachEvent('onAfterTaskAdd', function (id, item) {
        gantt.sort('start_date', false)
      })
      this.ganttAddTodayMarker()
    },
    ganttClearAll() {
      gantt.clearAll()
    },
    ganttAddTodayMarker() {
      const dateNow = new Date()
      const todayMarker = gantt.addMarker({
        start_date: new Date().setHours(0, 0, 0, 0),
        end_date: new Date(dateNow.setDate(dateNow.getDate() + 1)).setHours(0, 0, 0, 0),
        text: '',
        // title: dateToStr( new Date()),
      })
      gantt.getMarker(todayMarker)
    },
  },
  destroyed() {
    this.ganttClearAll()
  },
}
</script>

<style>
@import '~dhtmlx-gantt/codebase/dhtmlxgantt.css';
</style>

<style lang="scss" scoped>
.gantt {
  height: 100%;
  width: 100%;
  &__container {
    overflow: hidden;
    position: relative;
    height: 100%;
  }
  :deep() .timeline_cell {
    cursor: move !important;
  }
}
</style>
